import { axios } from '../index';
import { CreatePasswordManually } from '../types';
import { IDVerification } from '../../types';

export const createIDVerificationRequest = (userId: string, data: IDVerification) => {
  return axios.put(`/admin/documents/users/${userId}/id_verification`, data);
};

export const patchIDVerificationRequest = (userId: string, data: IDVerification) => {
  return axios.patch(`/admin/documents/users/${userId}/id_verification`, data);
};

export const verifyByPassportRequest = (userId: string) => {
  return axios.post(`/admin/documents/users/${userId}/id_verification/by_passport`);
};

export const createPassportManuallyRequest = ({ userId, data }: CreatePasswordManually) => {
  return axios.patch(`/admin/documents/users/${userId}/passports`, data);
};
